import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnmarApiService } from '../anmar-api.service';
import { AnmarBaseFormComponent } from '../shared/anmar-base-form.component';
import { ANMAR_RESOURCES } from '../shared/anmar-resources';

@Component({ selector: 'app-anmar-projects-form', templateUrl: '../blog/blog-form.component.html' })
export class AnmarProjectsFormComponent extends AnmarBaseFormComponent {
  config = ANMAR_RESOURCES['projects'];
  constructor(fb: FormBuilder, api: AnmarApiService, route: ActivatedRoute, router: Router, toastr: ToastrService) { super(fb, api, route, router, toastr); }

  override submit(): void {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }
    this.submitting = true;
    const payload = this.buildPayload();
    const request = this.isEditMode && this.recordId && payload instanceof globalThis.FormData
      ? this.api.updateMultipart(this.config.endpoint, this.recordId, payload)
      : (this.isEditMode && this.recordId ? this.api.update(this.config.endpoint, this.recordId, payload) : this.api.create(this.config.endpoint, payload));
    request.subscribe({ next: () => { this.submitting = false; this.router.navigate(['/anmar', this.config.route]); }, error: () => { this.submitting = false; } });
  }
}
